export const sortItems = (
  sortBy,
) => ((a, b) => a[sortBy].toString().localeCompare(b[sortBy].toString()));

export default {
  sortItems,
};
